// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MRJG","title":"Header_title__3mz6S","side":"Header_side__RrM1K"};